<div class="page-actions">
  <dcu-action-bar [actionBarConfig]="actionBarConfig"
                  (refreshChange)="refreshAll()"
                  [screenName]="'customer-list'"
                  [multiple]="false"
                  (closeChange)="close()"
                  [actionId]="'station-container-action-id'">
  </dcu-action-bar>
</div>
<div class="form-header">
  <dcu-header-info [headerInfo]="headerInfo"></dcu-header-info>
</div>

<dcu-body-content [refresh]="refresh"
                  [id]="'customer-list'"
                  [bodyContent]="bodyContent">
</dcu-body-content>
